import { Alert, AlertTitle } from "@mui/material";


export default function AlertEdit({ texto, severity }) {
    return (
        <Alert severity={severity ?? "warning"} style={{ marginBottom: 20 }}>
            <AlertTitle>{texto ?? 'Faça a edição apenas dos dados necessários  !'}</AlertTitle>
        </Alert>
    )
}